import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { VehiclesRoutingModule } from './vehicles-routing.module';
import { VehiclesPageComponent } from './vehicles-page.component';
import { VehicleCardComponent } from './vehicle-card.component';
import { AppMenuComponentModule } from '../../shared/components/app-menu/app-menu.module';
import { MinutesToTimePipe } from '../../shared/pipes/minutes-to-time.pipe';
@NgModule({
  imports: [
    CommonModule,
    VehiclesRoutingModule,
    SharedModule,
    AppMenuComponentModule,
  ],
  exports: [
    VehiclesPageComponent
  ],
  declarations: [
    VehiclesPageComponent,
    VehicleCardComponent
  ],
  providers: [
    MinutesToTimePipe
  ]
})
export class VehiclesModule { }
